// const apiUrl = 'http://billing.vaspostproductions.com:8000/api';
const apiUrl = "https://erp.skimitaracademy.com:8012/api";

export default apiUrl;
